const errorDuplicateGuest = 'More than 1 guest found';
const errorNotFound = 'No guest found';

const FORM_NAMES = {
  name: 'name',
  surname: 'surname',
  idNumber: 'id_number',
  dateOfBirth: 'date_of_birth',
  checkoutDate: 'checkout_date',
} as const;

export {FORM_NAMES, errorDuplicateGuest, errorNotFound};
